import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const ProjetService = {
    getProjetById: (id) => {
        return http.get(`${baseUrl}/cliami/projets/${id}`);
    },

    getProjets: () => {
        return http.get(`${baseUrl}/cliami/projets`);
    },

    saveProjet: (projet) => {
        if (!projet.projetId) {
            return http.post(`${baseUrl}/cliami/projets/create`, projet);
        } else {
            return http.put(`${baseUrl}/cliami/projets/update/${projet.projetId}`, projet);
        }
    },

    deleteGroup: (projet) => {
        return http.delete(`${baseUrl}/cliami/projets/delete/${projet.projetId}`);
    },
};

export default ProjetService;
